import { DocumentCommittee } from "../../../models/Request";

export const getUpdatedCommittees = (
  committees: DocumentCommittee[],
  committeeId?: number,
  employeeIds: number[] = []
) => {
  return committees.map((committee) => {
    const isCommitteeSelected = committee.committeeId === committeeId;

    let committeeEmployees = committee.committeeEmployees;

    if (isCommitteeSelected) {
      committeeEmployees = committeeEmployees.map((employee) => ({
        ...employee,
        isCommitteeEmployeeSelected: employeeIds.includes(
          employee.committeeEmployeeId
        ),
      }));
    }

    return {
      ...committee,
      isCommitteeSelected,
      committeeEmployees,
    };
  });
};
